<template>
  <li class="col-12 col-md-6 col-lg-4 mb-3">
    <div class="bg-primary rounded d-flex flex-column position-relative border border-lighter" style="height: 300px;"
    :style="[block.style === 'B' ? getBackgroundImage : false]"
    :class="{'blockOverlay' : block.style === 'B' && (block.text || block.title)}">
      <div v-if="(loggedInUser === 'Admin' || loggedInUser === 'SuperAdmin')" class="blockButtons d-flex flex-column">
        <button @click.prevent="showModalEdit = true" class="d-flex justify-content-center align-items-center border border-white mb-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"><rect width="100%" height="100%" fill="none"/><g class="currentLayer"><g><path fill="#231815" d="M13.1 5.9999996c-.1 0-.3 0-.4-.1l-3.2-3.2c-.1-.1-.1-.2-.1-.4s.1-.3.1-.4l1.3-1.3c.8-.8 2.1-.8 2.8 0l1.1 1.1c.8.8.8 2.1 0 2.8l-1.3 1.3c0 .2-.2.2-.3.2zm-2.5-3.7l2.5 2.5 1-1c.4-.4.4-1 0-1.4l-1.1-1.1c-.4-.4-1-.4-1.4 0l-1 1z"/><path fill="#231815" d="M.5 15.3999996c-.1 0-.3-.1-.4-.1-.1-.2-.1-.3-.1-.5l.6-3.8c0-.1.1-.2.1-.3l8.8-8.8c.2-.2.5-.2.7 0l3.2 3.2c.1.1.1.2.1.4s-.1.3-.1.4l-8.8 8.8c-.1.1-.2.1-.3.1l-3.8.6c.1 0 0 0 0 0zm1.1-4.1l-.5 3 3-.5 8.3-8.3-2.5-2.5-8.3 8.3z"/><path fill="#231815" d="M5.2 13.8999996c-.1 0-.3 0-.4-.1l-3.2-3.2c-.2-.2-.2-.5 0-.7s.5-.2.7 0l3.2 3.2c.2.2.2.5 0 .7 0 0-.1.1-.3.1z"/></g></g></svg>
        </button>
        <button @click.prevent="showModalDelete = true" class="d-flex justify-content-center align-items-center border border-white">
          <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11"><rect width="100%" height="100%" fill="none"/><g class="currentLayer"><g><path fill="#231815" d="M10.5499992 10.9500008c-.1 0-.3 0-.4-.1l-10-10c-.2-.2-.2-.5 0-.7s.5-.2.7 0l10 10c.2.2.2.5 0 .7 0 .1-.2.1-.3.1z"/><path fill="#231815" d="M.5499992 10.9500008c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l10-10c.2-.2.5-.2.7 0s.2.5 0 .7l-10 10c0 .1-.2.1-.3.1z"/></g></g></svg>
        </button>
      </div>

      <div v-if="block.style === 'A'" style="height: 120px;" :style="[getBackgroundImage]"></div>

      <div :class="['p-3 p-md-4', block.style === 'B' ? 'text-white my-auto' : 'bg-white flex-grow-1']">
        <h2 v-if="block.title" class="h3">{{ block.title }}</h2>
        <p v-if="block.text" class="blockText">{{ block.text }}</p>
      </div>

      <a :href="block.link" aria-label="Follow Link" target="_blank" rel="nofollow" class="blockLink" v-if="block.link"></a>
    </div>

    <modal v-if="showModalEdit" @close="showModalEdit = false">
      <div slot="body" class="py-0 px-md-4">
        <dashboard-form :existingBlock="block" @submitBlock="editBlock($event)" @removeBlock="removeBlock(block.id)" @closeModal="showModalEdit = false" />
      </div>
    </modal>

    <modal v-if="showModalDelete" @close="showModalDelete = false">
      <div slot="body" class="py-0 px-md-4">
        <div class="alert alert-warning">
          You are about to delete this block permanently. Are you sure?
        </div>
        <div class="d-flex justify-content-center">
          <button class="btn btn-outline-primary" @click.prevent="showModalDelete = false">Cancel</button>
          <button :class="['btn ml-2', processing ? 'btn-primary-dark' : 'btn-primary']" @click.prevent="removeBlock(block.id)">
            {{ !processing ? 'Confirm' : '' }}
            <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
          </button>
        </div>
      </div>
    </modal>
  </li>
</template>

<script>
import axios from 'axios'
import modal from '@/components/Modal'
import dashboardForm from './DashboardForm'

export default {
  name: 'DashboardBlock',
  components: {
    modal,
    'dashboard-form': dashboardForm
  },
  props: ['block'],
  data() {
    return {
      showModalEdit: false,
      showModalDelete: false,
      loggedInUser: localStorage.role,
      processing: false
    }
  },
  computed: {
    getBackgroundImage() {
      return { backgroundImage: `url(${this.block.image})`, backgroundPosition: 'center', backgroundSize: 'cover' }
    }
  },
  methods: {
    editBlock(updatedBlock) {
      this.$emit('editBlock', updatedBlock)
      this.showModalEdit = false
    },
    removeBlock(id) {
      this.processing = true
      axios.post(`${this.$api}/admin/block-delete/${id}`).then((response) => {
        if (response.data.status === 'success') {
          this.processing = false
          this.showModalDelete = false
          this.$emit('blockRemoved')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.blockText {
  line-height: 1.45;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/DashboardBlock.vue